<ng-template #downloadCentreForm role="document" let-modal>
  
  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="thisFormCancel()"
  ></app-modal-comp-header>
  
  <div class="modal-body">
    <form (ngSubmit)="thisFormSubmit()" [formGroup]="thisForm" class="tablelist-form" autocomplete="off" enctype="multipart/form-data">
      <!--
      <div class="uploads-bg-position uploads-bg" id="auth-particles">
        <div class="bg-overlay"></div>
      </div>
      -->
      <!--
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mt-sm-5 mb-2 text-white-50 position-relative" style="top: -40px;">
            <div>
              <a class="d-inline-block auth-logo">
                <img src="assets/images/SureSIM-Logo-Light-400.png" alt="" height="90">
              </a>
            </div>
            <p class="mt-3 fs-15 fw-medium">{{title}}</p>
          </div>
        </div>
      </div>
      -->
      <div class="row">
        <div class="col-12">
          <div class="mt-0 mb-0">
            <label class="form-label text-right"></label>
            <div class="alert border-0 {{alertColourProgress}} text-center" role="alert" style="margin-top: -30px;">
              <strong>Information</strong> - <span [innerHtml]="progressInformation" ></span>
            </div>
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="downloadFileTypeId-field" class="form-label text-right">File Type</label>
            <select
              class="form-select"
              name="downloadFileTypeId-field"
              id="downloadFileTypeId-field"
              formControlName="downloadFileTypeId"
              [ngClass]="{ 'is-invalid': formSubmitted && formOfThis['downloadFileTypeId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("downloadFileTypeId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
      <!--
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="filename-field" class="form-label">Filename</label>
            <input type="text" id="filename-field" class="form-control" placeholder="" formControlName="filename" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfThis['filename'].errors }" />
            @if(formOfThis['filename'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{filenameMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="contentType-field" class="form-label">Content Type</label>
            <input type="text" id="contentType-field" class="form-control" placeholder="" formControlName="contentType" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfThis['contentType'].errors }" />
            @if(formOfThis['contentType'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{contentTypeMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>
      -->
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="webTitle-field" class="form-label">Web Title</label>
            <input type="text" id="webTitle-field" class="form-control" placeholder="" formControlName="webTitle" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfThis['webTitle'].errors }" />
            @if(formOfThis['webTitle'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{webTitleMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="webText-field" class="form-label">Web Text</label>
            <textarea rows="5" d="webText-field" class="form-control" placeholder="" formControlName="webText" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfThis['webText'].errors }"></textarea>
            @if(formOfThis['webText'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{webTextMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>
      
      <div class="row" [hidden]="!editExisting || !allowFileOverwrites">
        <div class="col-12">
          <div class="mb-3">
            <div class="form-check form-switch form-switch-md d-flex align-items-center ps-0">
              <input
                class="form-check-input"
                id="change-downloadable-file-radio"
                [(ngModel)]="updateExistingFileUpload"
                [ngModelOptions]="{ standalone: true }"
                role="switch"
                style="margin-left:0"
                type="checkbox"
                (ngModelChange)="updateExistingFileUploadRadioChange()"
              >
              <label class="form-check-label mb-0 me-3" for="change-downloadable-file-radio">Change Downloadable File</label>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row" [hidden]="editExisting && (!allowFileOverwrites || !updateExistingFileUpload)">
        <div class="col-12">
          <div class="mb-3">
            <label for="fileData-field" class="form-label">Downloadable File</label>
            <input
              type="file"
              id="fileData-field"
              class="form-control"
              placeholder=""
              formControlName="fileData"
              data-lpignore="true"
              [ngClass]="{ 'is-invalid': formSubmitted && formOfThis['fileData'].errors }"
              (change)="uploadFileSelected($event)"
            />
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
      
      <div class="row" [hidden]="!editExisting || !allowWebImageOverwrites">
        <div class="col-12">
          <div class="mb-3">
            <div class="form-check form-switch form-switch-md d-flex align-items-center ps-0">
              <input
                class="form-check-input"
                id="change-web-image-radio"
                [(ngModel)]="updateExistingWebImageUpload"
                [ngModelOptions]="{ standalone: true }"
                role="switch"
                style="margin-left:0"
                type="checkbox"
                (ngModelChange)="updateExistingWebImageUploadRadioChange()"
              >
              <label class="form-check-label mb-0 me-3" for="change-web-image-radio">Change Web Image</label>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row" [hidden]="editExisting && (!allowWebImageOverwrites || !updateExistingWebImageUpload)">
        <div class="col-12">
          <div class="mb-3">
            <label for="webImageData-field" class="form-label">Web Image</label>
            <input
              type="file"
              id="webImageData-field"
              class="form-control"
              placeholder=""
              formControlName="webImageData"
              data-lpignore="true"
              [ngClass]="{ 'is-invalid': formSubmitted && formOfThis['webImageData'].errors }"
              (change)="webImageFileSelected($event)"
            />
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="visualOrder-field" class="form-label">Visual Order</label>
            <input
              class="form-control text-end"
              data-lpignore="true"
              formControlName="visualOrder"
              id="visualOrder-field"
              inputmode="numeric"
              maxlength="10"
              [ngClass]="{ 'is-invalid': formSubmitted && formOfThis['visualOrder'].errors }"
              pattern="\d*"
              placeholder=""
              type="text"
              (keypress)="onlyAllowDigits($event)"
              (paste)="blockNonNumericPaste($event)"
            />
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>

    </form>
  </div>

  <div class="modal-footer">
    <div class="hstack gap-2 justify-content-end">
      @if(editExisting) {
        <button type="button" class="btn btn-info" data-bs-dismiss="modal" (click)="newUpload()">New File Upload</button>
      }
      <button type="button" class="btn btn-info" data-bs-dismiss="modal" (click)="searchForDownloadableFile()">Edit Existing File Upload</button>
      <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="thisFormCancel()">Close</button>
      <button type="submit" class="btn btn-success" id="add-btn" (click)="thisFormSubmit()">Submit</button>
    </div>
  </div>
</ng-template>

<app-completed-modal-form #completedModalForm
></app-completed-modal-form>

<app-upload-centre-modal-form-search #uploadSearchForm
  (searchFormCancelled)="searchFormCancelled()"
  (searchGridRowClick)="searchGridRowClick($event)"
  (searchGridRowDblClick)="searchGridRowClick($event)"
></app-upload-centre-modal-form-search>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
